import { render, staticRenderFns } from "./InfraElemAlertDistribution.vue?vue&type=template&id=735278c4&scoped=true&"
import script from "./InfraElemAlertDistribution.vue?vue&type=script&lang=js&"
export * from "./InfraElemAlertDistribution.vue?vue&type=script&lang=js&"
import style0 from "./InfraElemAlertDistribution.vue?vue&type=style&index=0&id=735278c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735278c4",
  null
  
)

export default component.exports